import { render, staticRenderFns } from "./MinStatementSum.vue?vue&type=template&id=30beedba&"
import script from "./MinStatementSum.vue?vue&type=script&lang=js&"
export * from "./MinStatementSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports